import { createNativeStackNavigator } from '@react-navigation/native-stack'
import React from 'react'

import { Chat } from 'pages/Chat'
import { CoachesPage } from 'pages/Coaches'
import { ExplorePage } from 'pages/Explore'
import { FeedPage } from 'pages/Feed'
import { FollowersMembersPage } from 'pages/FollowersMembers'
import { MembershipsPage } from 'pages/Memberships'
import { NotificationsPage } from 'pages/Notifications'
import { ShareProfilePage } from 'pages/ShareProfile'
import { WorkoutsPage } from 'pages/Workouts'

import { links } from 'utils/constants'

const Stack = createNativeStackNavigator()

export const HomeStack = () => {
  return (
    <Stack.Navigator>
      <Stack.Screen
        component={FeedPage}
        name={links.FEED_PAGE}
        options={{
          title: 'Feed',
          headerShown: false,
        }}
      />

      <Stack.Screen
        component={NotificationsPage}
        name={links.NOTIFICATIONS_PAGE}
        options={{
          title: 'Notifications',
          headerShown: false,
        }}
      />

      <Stack.Screen
        component={MembershipsPage}
        name={links.MEMBERSHIPS_PAGE}
        options={{
          title: 'Groups',
          headerShown: false,
        }}
      />

      <Stack.Screen
        component={FollowersMembersPage}
        name={links.FOLLOWERS_MEMBERS_PAGE}
        options={{
          headerShown: false,
        }}
      />

      <Stack.Screen
        component={WorkoutsPage}
        name={links.WORKOUTS_PAGE}
        options={{
          title: 'Workouts',
          headerShown: false,
        }}
      />

      <Stack.Screen
        component={CoachesPage}
        name={links.TRAINERS_PAGE}
        options={{
          title: 'Coaches',
          headerShown: false,
        }}
      />

      <Stack.Screen
        name={links.SHARE_PROFILE_PAGE}
        component={ShareProfilePage}
        options={{
          title: 'Share',
          headerShown: false,
        }}
      />

      <Stack.Screen
        name={links.CHAT_PAGE}
        component={Chat}
        options={{
          title: 'Conversations',
          headerShown: false,
        }}
      />
      <Stack.Screen
        component={ExplorePage}
        name={links.EXPLORE_PAGE}
        options={{
          title: 'Explore',
          headerShown: false,
        }}
      />
    </Stack.Navigator>
  )
}
